import { useEffect } from "react";
import { useState } from "react";
import { useDispatch } from "react-redux";
import { dataLocalStorage, getLocalStorage } from "src/helper/publicFunction";
import { GetRequest, ManageRequest } from "./actions";
import { useParams } from "react-router";
import {
  Box,
  Card,
  CardContent,
  Typography,
  Grid,
  Avatar,
  Divider,
  Button,
  Chip,
  Alert,
  CardActions,
  Tooltip,
  Select,
  MenuItem,
  FormControl,
  Modal,
  IconButton,
  Skeleton,
  CircularProgress,
  TextField,
} from "@mui/material";
import UrlApi from "src/utils/Url";
import { IconBrandVisa, IconDownload, IconEye, IconX } from "@tabler/icons";
import { DatePicker, LocalizationProvider } from "@mui/x-date-pickers";
import { AdapterDateFns } from "@mui/x-date-pickers/AdapterDateFns";

const Request = () => {
  const { id } = useParams();
  const dispatch = useDispatch();
  const [loadingData, setLoadingData] = useState(true);
  const [data, setData] = useState({});
  const [status, setstatus] = useState("");
  const [visaFile, setVisaFile] = useState(null);
  let dataPrivileges = getLocalStorage(dataLocalStorage.privileges);
  const [open, setOpen] = useState(false);
  const handleOpen = () => setOpen(true);
  const handleClose = () => setOpen(false);
  const [expire_at, setexpire_at] = useState(null);
  const [fileModalOpen, setFileModalOpen] = useState(false);
  const [fileToView, setFileToView] = useState(null);
  const [loadingFile, setLoadingFile] = useState(false);
  const handleFileModalOpen = (fileUrl) => {
    setFileToView(fileUrl);
    setFileModalOpen(true);
  };
  const handleFileModalClose = () => {
    setFileModalOpen(false);
    // Cleanup blob URL to prevent memory leaks
    if (fileToView) {
      URL.revokeObjectURL(fileToView);
    }
    setFileToView(null);
  };

  const GetData = () => {
    setLoadingData(true);
    setData([]);
    dispatch(
      GetRequest({
        id: id,
        callback: (data) => {
          setData(data?.data);
          setstatus(data?.data?.status);
          setexpire_at(data?.data?.expire_at);
          setVisaFile({
            name: data?.data?.visa,
          });
          setLoadingData(false);
        },
      })
    );
  };

  useEffect(() => {
    GetData({ tableName: null, type: null });
  }, []);

  const handleFileChange = (event) => {
    setVisaFile(event.target.files[0]);
  };

  const handleUpload = () => {
    if (visaFile) {
      dispatch(
        ManageRequest({
          id: id,
          visa: visaFile,
          expire_at: expire_at,
          callback: (res) => {},
        })
      );
    }
  };

  const statusSeverityMap = {
    pending: "warning",
    approved: "success",
    rejected: "error",
    under_review: "info",
    expired: "error",
    cancelled: "error",
  };

  const alertSeverity = statusSeverityMap[data.status] || "info";

  const style = {
    position: "absolute",
    top: "50%",
    left: "50%",
    transform: "translate(-50%, -50%)",
    width: "90%",
    maxWidth: 800,
    bgcolor: "background.paper",
    borderRadius: 2,
    boxShadow: 24,
    p: 4,
    maxHeight: "80vh",
    overflowY: "auto",
  };

  const fileViewerStyle = {
    position: "absolute",
    top: "50%",
    left: "50%",
    transform: "translate(-50%, -50%)",
    width: { xs: "95%", sm: "90%", md: "85%", lg: "80%" },
    maxWidth: 1200,
    bgcolor: "background.paper",
    borderRadius: 3,
    boxShadow: 24,
    maxHeight: "95vh",
    overflow: "hidden",
    display: "flex",
    flexDirection: "column",
  };

  let dataStatus = "";

  switch (data?.status) {
    case "under_review":
      dataStatus = "Under Review";
      break;

    default:
      dataStatus = data?.status;
      break;
  }
  const downloadFile = async ({ downloadLink, type }) => {
    try {
      const dataUser = getLocalStorage(dataLocalStorage.userinfo);
      const baseUrl = `${UrlApi.baseUrlclient}request/download-private-file/${downloadLink}`;
      await fetch(baseUrl, {
        method: "GET",
        headers: {
          Authorization: `Bearer ${dataUser.token}`,
        },
      })
        .then(async (response) => {
          if (!response.ok) throw new Error("Failed to download file");
          return await response.blob();
        })
        .then((blob) => {
          const url = window.URL.createObjectURL(blob);
          const link = document.createElement("a");
          link.href = url;
          link.setAttribute("download", `FileName.${type}`);
          document.body.appendChild(link);
          link.click();
          document.body.removeChild(link);
          window.URL.revokeObjectURL(url);
        });
    } catch (error) {
      console.error("Error downloading file:", error);
    }
  };

  const isImageFile = (filename) => {
    const imageExtensions = [
      "jpg",
      "jpeg",
      "png",
      "gif",
      "webp",
      "svg",
      "bmp",
      "ico",
    ];
    const extension = filename?.split(".").pop()?.toLowerCase();
    return imageExtensions.includes(extension);
  };

  const ViewFile = async ({ file, type }) => {
    try {
      setLoadingFile(true);
      const dataUser = getLocalStorage(dataLocalStorage.userinfo);
      const baseUrl = `${UrlApi.baseUrlclient}request/read-private-file/${file}`;

      const response = await fetch(baseUrl, {
        method: "GET",
        headers: {
          Authorization: `Bearer ${dataUser.token}`,
        },
      });

      if (!response.ok) throw new Error("Failed to load file");

      const blob = await response.blob();
      const blobUrl = window.URL.createObjectURL(blob);

      handleFileModalOpen(blobUrl);
      setLoadingFile(false);
    } catch (error) {
      console.error("Error viewing file:", error);
      setLoadingFile(false);
    }
  };

  return (
    <>
      <Box p={4}>
        <Card variant="outlined">
          <CardContent>
            <Grid container spacing={3}>
              {loadingData ? (
                <>
                  <Box gap={3} ml={3} mb={3} mt={1}>
                    <Skeleton variant="circular" width={65} height={65} />
                  </Box>
                  <Box
                    flexDirection={"row"}
                    display={"flex"}
                    justifyContent={"space-evenly"}
                    alignItems={"center"}
                    gap={5}
                    width={"100%"}
                  >
                    <Box gap={3}>
                      <Skeleton variant="text" width={180} height={50} />
                      <Skeleton variant="text" width={180} height={50} />
                    </Box>
                    <Box gap={3}>
                      <Skeleton variant="text" width={180} height={50} />
                      <Skeleton variant="text" width={180} height={50} />
                    </Box>
                    <Box gap={3}>
                      <Skeleton variant="text" width={180} height={50} />
                      <Skeleton variant="text" width={180} height={50} />
                    </Box>
                    <Box gap={3}>
                      <Skeleton variant="text" width={180} height={50} />
                      <Skeleton variant="text" width={180} height={50} />
                    </Box>
                  </Box>
                </>
              ) : (
                <>
                  <Grid
                    item
                    xs={12}
                    display="flex"
                    alignItems="center"
                    gap={2}
                    mb={3}
                  >
                    <Avatar
                      src={data.client_image}
                      alt={data.client_name}
                      sx={{ width: 56, height: 56 }}
                    />
                    <Typography textTransform={"capitalize"} variant="h6">
                      {data.client_name}
                    </Typography>
                  </Grid>

                  <Grid item xs={12} sm={6} md={3}>
                    <Typography fontWeight={"bold"} variant="subtitle2" mb={1}>
                      Status
                    </Typography>

                    <Chip
                      color={alertSeverity}
                      variant="outlined"
                      label={dataStatus}
                      sx={{ textTransform: "capitalize" }}
                    />
                  </Grid>

                  <Grid item xs={12} sm={6} md={3}>
                    <Typography fontWeight={"bold"} variant="subtitle2" mb={1}>
                      Destination
                    </Typography>
                    <Typography>{data.destination}</Typography>
                    {/* {data.destination_image && (
                  <img
                    src={UrlApi.baseUrlImage + data.destination_image}
                    alt="Destination"
                    style={{
                      width: "100%",
                      maxHeight: 120,
                      objectFit: "contain",
                    }}
                  />
                )} */}
                  </Grid>

                  <Grid item xs={12} sm={6} md={3}>
                    <Typography fontWeight={"bold"} variant="subtitle2" mb={1}>
                      Visa Type
                    </Typography>
                    <Chip
                      color="primary"
                      variant="outlined"
                      label={data?.visa_type_name ?? "-"}
                    />
                  </Grid>

                  <Grid item xs={12} sm={6} md={3}>
                    <Typography fontWeight={"bold"} variant="subtitle2" mb={1}>
                      Visa fees
                    </Typography>
                    <Typography color="text.secondary">
                      ${data.visa_type_price_initial_price ?? "-"}
                    </Typography>
                  </Grid>

                  <Grid item xs={12} sm={6} md={3}>
                    <Typography fontWeight={"bold"} variant="subtitle2" mb={1}>
                      Visa Title
                    </Typography>
                    <Typography>{data.visa_type_price_title ?? "-"}</Typography>
                  </Grid>

                  <Grid item xs={12} sm={6} md={3}>
                    <Typography fontWeight={"bold"} variant="subtitle2" mb={1}>
                      Service fees
                    </Typography>
                    <Typography color="text.secondary">
                      ${data.visa_type_price_second_price ?? "-"}
                    </Typography>
                  </Grid>

                  <Grid item xs={12} sm={6} md={3}>
                    <Typography fontWeight={"bold"} variant="subtitle2">
                      Nationality
                    </Typography>
                    <Typography>{data.nationality ?? "-"}</Typography>
                  </Grid>

                  <Grid item xs={12} sm={6} md={3}>
                    <Typography fontWeight={"bold"} variant="subtitle2" mb={1}>
                      Requested At
                    </Typography>
                    <Typography>
                      {new Date(data.request_date).toLocaleString()}
                    </Typography>
                  </Grid>
                  <Grid item xs={12} sm={6} md={3}>
                    <Typography fontWeight="bold" variant="subtitle2" mb={1}>
                      Is Paid
                    </Typography>
                    <Box display="flex" alignItems="center" gap={1}>
                      <Chip
                        label={data.is_paid == 0 ? "No" : "Yes"}
                        color={data.is_paid == 0 ? "error" : "success"}
                        variant={data.is_paid == 0 ? "outlined" : "filled"}
                        size="small"
                        sx={{ fontWeight: 500 }}
                      />
                      {data.is_paid == 0 ? (
                        <Button
                          variant="contained"
                          color="error"
                          size="small"
                          sx={{ ml: 1, textTransform: "none", fontWeight: 500 }}
                          onClick={() => {
                            dispatch(
                              ManageRequest({
                                id: id,
                                is_paid: 1,
                                status: status,
                                visa: visaFile,
                                callback: () => {
                                  GetData();
                                },
                              })
                            );
                          }}
                        >
                          Mark as paid
                        </Button>
                      ) : (
                        <Button
                          variant="contained"
                          color="success"
                          size="small"
                          onClick={() => {
                            dispatch(
                              ManageRequest({
                                id: id,
                                is_paid: 0,
                                status: status,
                                visa: visaFile,
                                callback: () => {
                                  GetData();
                                },
                              })
                            );
                          }}
                        >
                          Mark as unpaid
                        </Button>
                      )}
                    </Box>
                  </Grid>
                  {data.is_paid == 1 && (
                    <Grid item xs={12} sm={6} md={3}>
                      <Typography
                        fontWeight={"bold"}
                        variant="subtitle2"
                        mb={1}
                      >
                        Payment type
                      </Typography>
                      <Typography>{data.payment_type}</Typography>
                    </Grid>
                  )}
                </>
              )}

              <Grid item xs={12}>
                <Divider sx={{ mt: 2, mb: 0 }} />
              </Grid>

              {/* USER ANSWERS  */}
              <Grid item xs={12}>
                {loadingData ? (
                  <Box gap={3}>
                    <Skeleton variant="text" width={180} height={40} />
                    <Skeleton variant="text" width={180} height={40} />
                  </Box>
                ) : (
                  <>
                    <Typography variant="h6" gutterBottom mb={2}>
                      User's answers
                    </Typography>
                    <Typography variant="body2" gutterBottom>
                      Below are the responses the user provided to the visa
                      application questions.
                    </Typography>
                  </>
                )}

                <Tooltip
                  placement="right"
                  color="info"
                  title={`${
                    data?.request_answers?.length ?? ""
                  } questions answered`}
                >
                  <Button
                    variant="outlined"
                    color="primary"
                    sx={{ mt: 2 }}
                    onClick={handleOpen}
                    disabled={
                      data?.request_answers?.length === 0 || loadingData
                    }
                  >
                    {loadingData ? (
                      <CircularProgress size={20} />
                    ) : (
                      "View User's Answers"
                    )}
                  </Button>
                </Tooltip>
                <Modal open={open} onClose={handleClose}>
                  <Box sx={style}>
                    <IconButton
                      onClick={handleClose}
                      sx={{ position: "absolute", right: 7, top: 7 }}
                    >
                      <IconX />
                    </IconButton>
                    <Typography variant="h6" mb={2}>
                      User's Answers
                    </Typography>
                    <Grid container spacing={2}>
                      {data?.request_answers &&
                        Array.isArray(data?.request_answers) &&
                        data?.request_answers?.length > 0 &&
                        data?.request_answers?.map((item, index) => (
                          <Grid item xs={12} sm={6} key={index}>
                            <Box
                              p={2}
                              borderRadius={2}
                              border={1}
                              borderColor="grey.300"
                            >
                              <Typography
                                variant="subtitle2"
                                color="text.secondary"
                              >
                                Question
                              </Typography>
                              <Typography
                                variant="body1"
                                fontWeight="bold"
                                mb={1}
                              >
                                {item.info_list?.list_name || "—"}
                              </Typography>
                              <Typography
                                variant="subtitle2"
                                color="text.secondary"
                              >
                                Answer
                              </Typography>
                              <Typography variant="body1">
                                {item.answer || "—"}
                              </Typography>
                            </Box>
                          </Grid>
                        ))}
                    </Grid>
                    <Box mt={3} textAlign="right">
                      <Button onClick={handleClose} variant="outlined">
                        Close
                      </Button>
                    </Box>
                  </Box>
                </Modal>

                {/* File Viewer Modal */}
                <Modal
                  open={fileModalOpen}
                  onClose={handleFileModalClose}
                  sx={{
                    backdropFilter: "blur(3px)",
                    backgroundColor: "rgba(0, 0, 0, 0.7)",
                  }}
                >
                  <Box sx={fileViewerStyle}>
                    {/* Header */}
                    <Box
                      sx={{
                        display: "flex",
                        justifyContent: "space-between",
                        alignItems: "center",
                        p: 2,
                        borderBottom: 1,
                        borderColor: "divider",
                      }}
                    >
                      <Typography variant="h6" fontWeight="bold">
                        Document Preview
                      </Typography>
                      <IconButton
                        onClick={handleFileModalClose}
                        sx={{
                          "&:hover": { bgcolor: "error.light", color: "white" },
                        }}
                      >
                        <IconX />
                      </IconButton>
                    </Box>

                    {/* Image Container */}
                    <Box
                      sx={{
                        flex: 1,
                        display: "flex",
                        justifyContent: "center",
                        alignItems: "center",
                        p: { xs: 2, sm: 3, md: 4 },
                        bgcolor: "#f5f5f5",
                        overflow: "auto",
                      }}
                    >
                      {loadingFile ? (
                        <Box textAlign="center">
                          <CircularProgress size={50} />
                          <Typography
                            variant="body2"
                            mt={2}
                            color="text.secondary"
                          >
                            Loading document...
                          </Typography>
                        </Box>
                      ) : (
                        fileToView && (
                          <Box
                            component="img"
                            src={fileToView}
                            alt="Document preview"
                            sx={{
                              maxHeight: "100%",
                              height: "auto",
                              width: "40%",
                              objectFit: "contain",
                              borderRadius: 2,
                              boxShadow: "0 4px 20px rgba(0,0,0,0.15)",
                              bgcolor: "white",
                            }}
                          />
                        )
                      )}
                    </Box>

                    {/* Footer */}
                    <Box
                      sx={{
                        display: "flex",
                        justifyContent: "flex-end",
                        gap: 2,
                        p: 2,
                        borderTop: 1,
                        borderColor: "divider",
                      }}
                    >
                      <Button
                        onClick={handleFileModalClose}
                        variant="contained"
                        color="primary"
                        size="large"
                      >
                        Close
                      </Button>
                    </Box>
                  </Box>
                </Modal>
              </Grid>

              <Grid item xs={12}>
                <Divider sx={{ mt: 2, mb: 0 }} />
              </Grid>

              {/* DOCUMENT DOWNLOAD  */}
              <Grid item xs={12}>
                <Typography variant="h6" gutterBottom mb={2}>
                  User's documents
                </Typography>
                {Array.isArray(data?.request_documents) &&
                data?.request_documents?.length > 0 ? (
                  data?.request_documents?.map((doc, idx) => {
                    return (
                      <Card
                        variant="outlined"
                        key={idx}
                        sx={{ maxWidth: 500, mx: "auto", mt: 4, p: 2 }}
                      >
                        <CardContent>
                          <Box display="flex" alignItems="center" gap={2}>
                            <Avatar
                              variant="rounded"
                              src={
                                doc?.icon
                                  ? UrlApi.baseUrlImage + doc.icon
                                  : undefined
                              }
                              sx={{ bgcolor: "primary.main" }}
                            />
                            {/* {fileName?.charAt(0).toUpperCase()} */}
                            {/* {doc?.documents_name} */}

                            <Box>
                              <Typography variant="subtitle1" fontWeight="bold">
                                {/* {fileName} */}
                                {doc?.documents_name}
                              </Typography>
                              <Typography
                                variant="body2"
                                color="text.secondary"
                              >
                                Click below to download this document.
                              </Typography>
                            </Box>
                          </Box>
                        </CardContent>
                        <CardActions>
                          {isImageFile(doc.file) && (
                            <Tooltip title="View">
                              <Button
                                disabled={loadingData || loadingFile}
                                variant="outlined"
                                startIcon={
                                  loadingFile ? (
                                    <CircularProgress size={20} />
                                  ) : (
                                    <IconEye />
                                  )
                                }
                                onClick={() => {
                                  ViewFile({
                                    file: doc.file,
                                    type: doc.file.split(".")[1],
                                  });
                                }}
                              >
                                {loadingFile ? "Loading..." : "View"}
                              </Button>
                            </Tooltip>
                          )}
                          <Tooltip title="Download">
                            <Button
                              disabled={loadingData}
                              variant="outlined"
                              startIcon={<IconDownload />}
                              onClick={() =>
                                downloadFile({
                                  downloadLink: doc.file,
                                  type: doc.file.split(".")[1],
                                })
                              }
                            >
                              {loadingData ? (
                                <CircularProgress size={20} />
                              ) : (
                                "Download"
                              )}
                            </Button>
                          </Tooltip>
                        </CardActions>
                      </Card>
                    );
                  })
                ) : loadingData ? (
                  <Box
                    flexDirection={"row"}
                    display={"flex"}
                    justifyContent={"space-evenly"}
                    alignItems={"center"}
                    gap={5}
                    width={"100%"}
                  >
                    <Skeleton variant="text" width={230} height={200} />
                    <Skeleton variant="text" width={230} height={200} />
                  </Box>
                ) : (
                  !loadingData &&
                  data?.request_documents &&
                  data?.request_documents?.length === 0 && (
                    <Box justifyContent={"center"} display={"flex"}>
                      <Alert
                        variant="filled"
                        severity="info"
                        sx={{ bgcolor: "lightgray" }}
                      >
                        Looks empty
                      </Alert>
                    </Box>
                  )
                )}
              </Grid>

              <Grid item xs={12}>
                <Divider sx={{ mt: 2, mb: 3 }} />
              </Grid>

              {/* VISA UPLOAD  */}
              {/* Upload Visa Section */}
              <Grid item xs={12} md={6}>
                <Typography variant="h6" gutterBottom mb={2}>
                  Upload Visa for User
                </Typography>
                <Box
                  display="flex"
                  alignItems="center"
                  gap={2}
                  mt={1}
                  sx={{ flexDirection: { xs: "column", md: "row" } }}
                >
                  <Button
                    disabled={data?.status !== "approved"}
                    variant="outlined"
                    component="label"
                    startIcon={<IconBrandVisa />}
                  >
                    {visaFile?.name ? "Change File" : "Choose File"}
                    <input
                      type="file"
                      hidden
                      onChange={handleFileChange}
                      accept="application/pdf,image/*"
                    />
                  </Button>
                  <LocalizationProvider dateAdapter={AdapterDateFns}>
                    <DatePicker
                      disabled={data?.status !== "approved"}
                      minDate={new Date().setDate(new Date().getDate() + 1)}
                      value={expire_at}
                      onChange={(newValue) => setexpire_at(newValue)}
                      renderInput={(params) => (
                        <TextField
                          placeholder="Select Expire Date"
                          {...params}
                          sx={{
                            "& .MuiInputBase-root": {
                              height: "2.2rem",
                            },
                          }}
                        />
                      )}
                    />
                  </LocalizationProvider>
                </Box>
                {visaFile && (
                  <Typography
                    noWrap
                    variant="body2"
                    sx={{
                      maxWidth: "50%",
                      overflow: "hidden",
                      textOverflow: "ellipsis",
                      whiteSpace: "nowrap",
                      wordBreak: "break-word",
                      padding: "5px",
                      bgcolor: "background.paper",
                    }}
                  >
                    {visaFile?.name}
                  </Typography>
                )}
                <Tooltip color="info" title="Confirm and upload">
                  <Button
                    variant="outlined"
                    color="primary"
                    sx={{ mt: 2 }}
                    onClick={handleUpload}
                    disabled={!visaFile || loadingData}
                  >
                    Upload
                  </Button>
                </Tooltip>
              </Grid>

              {/* Visa Status Update Section */}
              <Grid item xs={12} md={6}>
                <Typography variant="h6" gutterBottom mb={2}>
                  Update Visa Status
                </Typography>
                <FormControl fullWidth>
                  <Select
                    disabled={loadingData}
                    inputProps={{ "aria-label": "Without label" }}
                    displayEmpty
                    labelId="visa-status-label"
                    value={status}
                    defaultValue={status}
                    onChange={(e) => setstatus(e.target.value)}
                  >
                    <MenuItem value="pending">Pending</MenuItem>
                    <MenuItem value="approved">Approved</MenuItem>
                    <MenuItem value="rejected">Rejected</MenuItem>
                    <MenuItem value="under_review">Under Review</MenuItem>
                    <MenuItem value="expired">Expired</MenuItem>
                    <MenuItem value="cancelled">Cancelled</MenuItem>
                  </Select>
                </FormControl>
                <Button
                  variant="outlined"
                  sx={{ mt: 2 }}
                  onClick={() => {
                    dispatch(
                      ManageRequest({
                        id: id,
                        status: status,
                        visa: visaFile,
                        callback: () => {
                          GetData();
                        },
                      })
                    );
                  }}
                  disabled={loadingData}
                >
                  Save Status
                </Button>
              </Grid>
            </Grid>
          </CardContent>
        </Card>
      </Box>
    </>
  );
};

export default Request;
